// src/components/Historia.jsx

export default function Historia() {
  return (
    <section className="historia">
      <h2>NUESTRA HISTORIA</h2>
      <p className="slogan-historia">
        Detail Center, Donde soñar se convierte en arte.
      </p>
      <p>
        Detail Center nació del amor por los autos y la dedicación al detalle.
        Comenzamos como un pequeño emprendimiento familiar, con la convicción de brindar un servicio honesto,
        profesional y personalizado. Cada vehículo que pasa por nuestras manos es tratado como propio,
        porque entendemos lo que significa confiarle a alguien lo que más cuidás.
      </p>
    </section>
  );
}
